import React, { useEffect, useState } from 'react';
import { Download, MoreVertical, Share, X } from 'lucide-react';

const KEY = 'bond_install_dismissed';
const standalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isAndroid = () => /android/i.test(window.navigator.userAgent);

export default function InstallBanner() {
  const [evt, setEvt] = useState(() => window.__bondInstall || null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === '1' || standalone() || window.innerWidth >= 768);
  useEffect(() => {
    const ready = () => setEvt(window.__bondInstall);
    const done = () => setHidden(true);
    window.addEventListener('bond-install-ready', ready);
    window.addEventListener('appinstalled', done);
    return () => { window.removeEventListener('bond-install-ready', ready); window.removeEventListener('appinstalled', done); };
  }, []);
  if (hidden || (!evt && !isIos() && !isAndroid())) return null;
  const close = () => { localStorage.setItem(KEY, '1'); setHidden(true); };
  const install = async () => {
    evt.prompt();
    const { outcome } = await evt.userChoice;
    window.__bondInstall = null;
    if (outcome === 'accepted') close(); else { setEvt(null); setHidden(true); }
  };
  return (
    <div className="fixed inset-x-3 bottom-3 z-40 flex items-center gap-3 rounded-xl border p-3 shadow-2xl" style={{ marginBottom: 'env(safe-area-inset-bottom)', background: '#050505', color: '#FFFFFF', borderColor: 'rgba(212,175,55,.4)' }} data-testid="pwa-install-banner">
      <img src="/icons/icon-192.png" alt="BOND" className="w-11 h-11 rounded-lg shrink-0" />
      <div className="flex-1 min-w-0 text-sm leading-snug">
        <p className="font-semibold" style={{ color: '#FFFFFF' }}>Installa l'app BOND</p>
        {evt ? <p className="text-xs" style={{ color: '#BDBDBD' }}>Aprila dalla schermata Home, come un'app.</p>
          : isAndroid() ? <p className="text-xs" style={{ color: '#BDBDBD' }} data-testid="pwa-install-android-hint">Apri il menu <MoreVertical size={12} className="inline -mt-0.5" /> del browser e tocca «Installa app» o «Aggiungi a schermata Home».</p>
          : <p className="text-xs" style={{ color: '#BDBDBD' }}>Tocca <Share size={12} className="inline -mt-0.5" /> Condividi, poi «Aggiungi alla schermata Home».</p>}
      </div>
      {evt && <button onClick={install} className="h-9 px-3 rounded-full text-sm font-semibold inline-flex items-center gap-1" style={{ background: '#D4AF37', color: '#000' }} data-testid="pwa-install-btn"><Download size={14} />Installa</button>}
      <button onClick={close} aria-label="Chiudi" className="p-1" style={{ color: '#BDBDBD' }} data-testid="pwa-install-close"><X size={16} /></button>
    </div>
  );
}
